<template>
  <b-row>
    <b-col>
      <cabecalho-repeticao
        :titulo="'Sócio'"
        :show-icon="false"
      >
        <template
          v-if="socio.responsavelRFB"
          #conteudo
        >
          <b-badge
            variant="none"
            style="background-color: #3f51b5;"
          >
            Responsável RFB</b-badge>
        </template>
      </cabecalho-repeticao>
      <b-row>
        <b-col cols="3">
          <b-form-group label="Sócio">
            <b-input
              v-model="socio.nome"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label="Tipo de inscrição">
            <b-select
              ref="tipoInscricao"
              v-model="socio.tipoInscricao"
              :options="['CPF', 'CNPJ']"
              :disabled="true"
              @change="constroiMascaraInscricao()"
            />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label="Inscrição">
            <b-input
              v-model="socio.inscricao"
              v-mask="constroiMascaraInscricao()"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label="Data de nascimento">
            <data-input
              v-model="socio.dataNascimento"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Profissão">
            <b-form-input
              v-model="socio.profissao"
              :disabled="true"
              class="desabilitar"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        align-h="between"
        class="mb-1"
      >
        <b-col cols="5">
          <div style="display: flex;justify-content: space-between;">
            <div>
              <legend class="col-form-label pt-0" />
              <b-form-checkbox
                v-model="socio.socioAdministrador"
                :disabled="true"
                class="checkbox"
              >
                Sócio administrador
              </b-form-checkbox>
            </div>
            <div style="margin-left: 1rem;">
              <legend class="col-form-label pt-0" />
              <b-form-checkbox
                v-model="socio.responsavelRFB"
                :disabled="true"
                class="checkbox"
              >
                Responsável perante a RFB
              </b-form-checkbox>
            </div>
          </div>
        </b-col>
        <b-col cols="auto">
          <b-form-checkbox
            v-model="mostrarMais"
            class="custom-control-primary"
            style="float:right"
            name="check-button"
            switch
          >
            <label style="font-size: 1rem">Exibir informações detalhadas</label>
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row
        v-if="mostrarMais"
        class="mt-50"
      >
        <b-col cols="12">
          <hr
            class="mx-0 mt-0 mb-0"
            style="border-top: 1px solid #a3a4a66b !important;"
          >
        </b-col>
      </b-row>
      <b-tabs
        v-if="mostrarMais"
        @input="alterandoAba"
      >
        <b-tab
          no-body
          title="Dados gerais"
        >
          <div>
            <b-row>
              <b-col cols="4">
                <funcao-select
                  v-model="socio.funcao"
                  :disabled="true"
                  :require="false"
                  class="desabilitar"
                />
              </b-col>
              <b-col cols="3">
                <b-form-group label="RG">
                  <b-input
                    v-model="socio.rg"
                    :disabled="true"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Órgão Emissor">
                  <orgao-emissor-select
                    v-model="socio.orgaoEmissor"
                    :disabled="true"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="UF">
                  <estado-select
                    v-model="socio.ufUsuario"
                    :disabled="true"
                    class="desabilitar"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2">
                <b-form-group label="Nacionalidade">
                  <b-form-input
                    v-model="socio.nacionalidade"
                    :disabled="true"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Estado Civil">
                  <b-form-input
                    v-model="socio.estadoCivil"
                    :disabled="true"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Data entrada">
                  <data-input
                    v-model="socio.dataEntrada"
                    :disabled="true"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="5">
                <b-form-group label="E-mail">
                  <b-form-input
                    v-model="socio.email"
                    :disabled="true"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <dinheiro-input
                  v-model="socio.valorSocietaria"
                  :label="'Participação societária (R$)'"
                  :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
                  :disabled="true"
                />
              </b-col>
              <b-col cols="3">
                <b-form-group label="Participação societária (%)">
                  <b-form-input
                    v-model="socio.porcentagemSocietaria"
                    :disabled="true"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <telefone-celular
                  :value="socio.telefoneContato"
                  :disabled="true"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col
                class="mb-1"
                cols="12"
                style="display: flex; align-items: center;"
              >
                <div>
                  <legend class="col-form-label pt-0" />
                  <b-form-checkbox
                    v-model="socio.residenteExterior"
                    :disabled="true"
                    class="checkbox checkbox-residente-exterior"
                  >
                    Residente no exterior
                  </b-form-checkbox>
                </div>
                <fieldset class="divisoria-resisdente-exterior" />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <b-form-group label="CEP">
                  <b-input-group>
                    <masked-input
                      ref="cep"
                      v-model="socio.cep"
                      :mask="[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
                      class="form-control"
                      :disabled="true"
                    />
                    <b-input-group-append>
                      <b-button
                        v-b-tooltip.hover
                        title="Buscar endereço completo pelo CEP"
                        variant="primary"
                        style="float:right"
                        :disabled="true"
                      >
                        <feather-icon icon="SearchIcon" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-form-group
                label="Endereço"
                class="col-md-6"
              >
                <b-form-input
                  v-model="socio.logradouro"
                  :disabled="true"
                />
              </b-form-group>
              <b-form-group
                label="Número"
                class="col-md-3"
              >
                <b-form-input
                  v-model="socio.numero"
                  :disabled="true"
                />
              </b-form-group>
            </b-row>
            <b-row>
              <b-form-group
                label="Complemento"
                class="col-md-3"
              >
                <b-form-input
                  v-model="socio.complemento"
                  :disabled="true"
                />
              </b-form-group>
              <b-form-group
                label="Bairro"
                class="col-md-4"
              >
                <b-form-input
                  v-model="socio.bairro"
                  :disabled="true"
                />
              </b-form-group>
              <b-col cols="3">
                <legend class="col-form-label pt-0">
                  Cidade
                </legend>
                <municipio-select
                  v-model="socio.cidade"
                  :disabled="true"
                  class="desabilitar"
                />
              </b-col>
              <b-col cols="2">
                <legend class="col-form-label pt-0">
                  Estado
                </legend>
                <estado-select
                  v-model="socio.uf"
                  :disabled="true"
                  class="desabilitar"
                />
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab
          no-body
          title="Certificados"
        >
          <div style="position: relative;">
            <b-row>
              <b-col>
                <b-form-checkbox
                  v-model="empresa.exibirCertificadoVencidoECpf"
                  class="custom-control-primary"
                  style="float:right; position: absolute; right: 35px; top: -32px;"
                  name="check-button"
                  switch
                  @change="getCertificados"
                >
                  <label style="font-size: 1rem">Exibir Certificados Vencidos</label>
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row
              v-if="certificados && certificados.length > 0"
              style="display: flex; flex-direction: column;"
            >
              <b-col
                v-for="certificado in certificados"
                :key="certificado.id"
              >
                <dados-certificado
                  :value="certificado"
                  :modelo-certificado="'e-CPF'"
                />
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col>
                <dados-certificado
                  :value="{}"
                  :modelo-certificado="'e-CPF'"
                />
              </b-col>
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.icone-mais {
  padding: 0.4rem 1rem;
}

.desabilitar .vs--disabled .vs__dropdown-toggle,
.desabilitar .vs--disabled .vs__search {
  background-color: #efefef;
}

.checkbox .custom-control-label {
  color: #6e6b7b !important;
}

.checkbox-residente-exterior label {
  font-size: 12px !important;
}

.divisoria-resisdente-exterior {
  width: 80%;
  border-bottom: 1px solid;
  opacity: 0.3; margin-top: 11px;
}
</style>

<script>
import { mapGetters } from 'vuex'
import apiCertificado from '@/app-modulo/comuns/certificado/shared/services/api'

export default {
  name: 'SociosEmpresa',
  components: {
    CabecalhoRepeticao: () => import('@/shared/components/cabecalho-repeticao/CabecalhoRepeticao.vue'),
    DinheiroInput: () => import('@/shared/components/dinheiro-input/DinheiroInput.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    OrgaoEmissorSelect: () => import('@/shared/components/orgao-emissor-select/OrgaoEmissorSelect.vue'),
    FuncaoSelect: () => import('@/shared/components/funcao-select/FuncaoSelect.vue'),
    EstadoSelect: () => import('@/shared/components/estado-select/EstadoSelect.vue'),
    TelefoneCelular: () => import('@/shared/components/telefone-celular/TelefoneCelular.vue'),
    MunicipioSelect: () => import('@/shared/components/municipio-select/MunicipioSelect.vue'),
    DadosCertificado: () => import('@/app-modulo/comuns/empresa/shared/components/aba-certificados/shared/dados-certificado/DadosCertificado.vue'),
  },
  props: {
    socio: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('empresa', ['empresa']),
  },
  // eslint-disable-next-line vue/order-in-components
  data() {
    return {
      mostrarMais: false,
      abaAcessada: 0,
      certificados: [],
    }
  },
  created() {
    this.socio.tipoInscricao = !this.socio.tipoInscricao ? 'CPF' : this.socio.tipoInscricao
    this.getCertificados()
  },
  methods: {
    constroiMascaraInscricao() {
      if (this.socio.tipoInscricao === 'CPF') {
        return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
      }
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    alterandoAba(newIndex) {
      this.abaAcessada = newIndex
      if (newIndex === 3) {
        this.mostrarContatos = true
      } else {
        this.mostrarContatos = false
      }
    },
    getCertificados() {
      if (this.socio.usuarioExternoId > 0) {
        apiCertificado.getCertificadoBySocioId(this.socio.usuarioExternoId, this.empresa.exibirCertificadoVencidoECpf)
          .then(payload => {
            this.certificados = payload.data
          })
          .catch(err => {
            this.$erro(err)
          })
      }
    },
  },
}
</script>
